/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 *
 * Google CDN, Latest jQuery
 * To use the default WordPress version of jQuery, go to lib/config.php and
 * remove or comment out: add_theme_support('jquery-cdn');
 * ======================================================================== */

(function ($) {
    // Use this variable to set up the common and page specific functions. If you
    // rename this variable, you will also need to rename the namespace below.
    var Sage = {
        // All pages
        'common': {
            init: function () {
                // JavaScript to be fired on all pages
            },
            finalize: function () {
                // JavaScript to be fired on all pages, after page specific JS is fired
            }
        },
        // contact-us page
        'contact_us': {
            init: function () {
                // JavaScript to be fired on all pages
            },
            finalize: function () {
                //Load map
                var paper = new Snap("svg");
                Snap.load("/wp-content/themes/diestwell/assets/images/worldmap.svg", function (f) {
                    // $(".svg-holder").each(function(){
                    //     var elem = paper.select("#" + $(this).attr("id"));
                    //     var hoverover = function() { elem.animate({ r: '10' }, 300, mina.bounce ); };
                    //     var hoverout = function() { elem.animate({ r: '5' }, 300, mina.bounce ); };
                    //     elem.hover( hoverover, hoverout );
                    // });

                    $('[data-toggle="popover"]').popover({"container":"body", trigger: "manual" , html: true, animation:false})
                        .on("mouseenter", function () {
                            var _this = this;
                            $(this).popover("show");
                            $(".popover").on("mouseleave", function () {
                                $(_this).popover('hide');
                            });

                            var elem = paper.select("#" + $(this).attr("id"));
                            elem.animate({ r: '10' }, 300, mina.bounce ); 
                        }).on("mouseleave", function () {
                            var _this = this;
                            setTimeout(function () {
                                if (!$(".popover:hover").length) {
                                    $(_this).popover("hide");
                                }
                            }, 300);
                            var elem = paper.select("#" + $(_this).attr("id"));
                            elem.animate({ r: '5' }, 300, mina.bounce ); 
                    });
                });
            }
        },
        // Home page
        'home': {
            /**
            * load map data from the selec
            */
            loadMapData : function() {
                var elem = $(".map-box .selection option:selected");
                $(".home-page .map-box .layer").fadeOut(function() {
                    $(this).attr("src",elem.data("layer")).fadeIn();
                });
                $(".home-page .address-box").fadeOut(function() {
                    $(this).html(elem.data("address")).fadeIn();
                });
            },
            init: function () {
                // JavaScript to be fired on the home page
            },
            finalize: function () {
                //uniformize menus
                $('.home-page .home-menu').css("height", $(".home-page .home-menu").height());
                //Swiper
                var carrousel = $('.home-page .carrousel .swiper-container');
                if (carrousel.length) {
                    var swiper = new Swiper('.swiper-container', {
                        pagination: '.swiper-pagination',
                        paginationClickable: true
                    });
                    $('.home-page .carrousel .swiper-container').css("height", $(".home-page .home-menu").height());
                    $('.home-page .carrousel .swiper-container .swiper-slide').css("width", $(".home-page .carrousel").width());
                    $('.home-page .carrousel .swiper-container .swiper-slide').css("height", $(".home-page .carrousel").height());
                    /**
                    * Map
                    */
                    //preselect first item
                    this.loadMapData();
                    //listeners for changes
                    var that = this;
                    $(".map-box .selection select").change(function(){
                       that.loadMapData();
                    });
                }
            }
        },
        // About us page, note the change from about-us to about_us.
        'about_us': {
            init: function () {
                // JavaScript to be fired on the about us page
            }
        }
    };

    // The routing fires all common scripts, followed by the page specific scripts.
    // Add additional events for more control over timing e.g. a finalize event
    var UTIL = {
        fire: function (func, funcname, args) {
            var fire;
            var namespace = Sage;
            funcname = (funcname === undefined) ? 'init' : funcname;
            fire = func !== '';
            fire = fire && namespace[func];
            fire = fire && typeof namespace[func][funcname] === 'function';

            if (fire) {
                namespace[func][funcname](args);
            }
        },
        loadEvents: function () {
            // Fire common init JS
            UTIL.fire('common');

            // Fire page-specific init JS, and then finalize JS
            $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
                UTIL.fire(classnm);
                UTIL.fire(classnm, 'finalize');
            });

            // Fire common finalize JS
            UTIL.fire('common', 'finalize');
        }
    };

    // Load Events
    $(document).ready(UTIL.loadEvents);


})(jQuery); // Fully reference jQuery after this point.